import script from "./EditIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./EditIcon.vue?vue&type=script&setup=true&lang=js"

import "./EditIcon.vue?vue&type=style&index=0&id=a4c10920&lang=scss"

const __exports__ = script;

export default __exports__